/**
 * Action type to signal that a new API message was received.
 */
export const API_MESSAGE_RECEIVED = 'API_MESSAGE_RECEIVED';

/**
 * Action type to send an API message.
 */
export const SEND_API_MESSAGE = 'SEND_API_MESSAGE';
